import { type UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query';
import {
  getDataRequest as apiGetDataRequest,
  type BulkCreateDataRequestNotesBody,
  type BulkUpdateDataRequestsBody,
  bulkCreateDataRequestNotes,
  bulkUpdateDataRequests,
} from '~/api/civilsearch';
import type { DataRequestV2 } from '~/common/types';

export interface UseGetDataRequestOptions {
  requestId?: string;
}

export function useGetDataRequest<T = DataRequestV2>(
  { requestId }: UseGetDataRequestOptions,
  options?: Partial<UseQueryOptions<T, Error, T, (string | UseGetDataRequestOptions)[]>>,
) {
  return useQuery({
    enabled: !!requestId,
    staleTime: 0,
    gcTime: 0,
    queryKey: ['data-request-v2', { requestId }],
    queryFn: () => apiGetDataRequest<T>(requestId!),
    ...options,
  });
}

export function useBulkUpdateDataRequests() {
  return useMutation({
    mutationFn: (body: BulkUpdateDataRequestsBody) => bulkUpdateDataRequests(body),
  });
}

export function useBulkCreateDataRequestNotes() {
  return useMutation({
    mutationFn: (body: BulkCreateDataRequestNotesBody) => bulkCreateDataRequestNotes(body),
  });
}
